import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { defaultProfile } from '@shared/types/Profile';
import type { Profile } from '@shared/types/Profile';
import { NameHelper } from '@shared/helper/NameHelper';

export const useBaseLawyerStore = defineStore('baseLawyer', () => {
  const profile = ref<Profile>(defaultProfile);
  const userId = ref();

  const formattedName = computed(() => NameHelper().getFormattedName(profile.value));

  return { profile, userId, formattedName };
});
